import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
import { useAuth } from 'modules/auth/hooks'
import { SIGN_UP_URL } from 'modules/auth/constants'

export const SignUp = () => {
    const { user, login, signUp } = useAuth()

    useEffect(() => {
        if (user) {
            window.location.assign('/home')
        } else {
            window.location.assign(SIGN_UP_URL)
        }
    }, [])
    return (
        <>
            <Breadcrumb title='Sign Up' />
            <div className='static-page' style={{ paddingBottom: '0px' }}>
                <Container style={{ paddingBottom: '150px' }}>
                    <Row className='align-items-center'>
                        <Col lg={6}>

                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}
